import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { isObject, isArray } from '@utiljs/is';

var ErrorMessage = function ErrorMessage(props) {
  var error = props.error,
      visible = props.visible;
  var errorString = isObject(error) || isArray(error) ? _Object$values(error).join(' ') : error;
  return error && visible ? /*#__PURE__*/React.createElement("p", {
    className: "help-block"
  }, errorString) : null;
};

ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  visible: PropTypes.bool
};
ErrorMessage.defaultProps = {
  error: undefined,
  visible: true
};
export default ErrorMessage;